<div class="providers-section">

  <!-- Picker: offers only providers not already listed. -->
  <div class="provider-add">
    <mat-form-field class="provider-add-field" subscriptSizing="dynamic">
      <mat-label>Add insurance provider</mat-label>
      <mat-select [(ngModel)]="selectedProviderIndex" (selectionChange)="addProvider($event.value); $event.source.value = null"
        [disabled]="readonly() || !availableIndices.length" placeholder="Select a provider">
        @for (index of availableIndices; track index) {
        <mat-option [value]="index">
          {{ providers[index].name }}
          @if (providers[index].firmCode) {
          <span class="option-code">· {{ providers[index].firmCode }}</span>
          }
        </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- <span class="provider-add-hint">
      @if (availableIndices.length) {
        {{ availableIndices.length }} provider(s) available to add
      } @else {
        All providers have been added
      }
    </span> -->
  </div>

  @if (listedIndices.length) {
  <div class="providers-table">
    <div class="providers-head">
      <span class="col-name">Provider</span>
      <span class="col-firm">Firm Code</span>
      <span class="col-user">User Code</span>
      @if (!readonly()) {
      <span class="col-action"></span>
      }
    </div>

    <!-- Tracked by index: each row is bound to the form array position, not the name. -->
    @for (index of listedIndices; track index) {
    <div class="provider-row">
      <span class="col-name">
        <span class="provider-name">{{ providers[index].name }}</span>
        @if (providers[index].note) {
        <span class="provider-note">{{ providers[index].note }}</span>
        }
      </span>
      <span class="col-firm">{{ providers[index].firmCode || '—' }}</span>
      <span class="col-user">
        <mat-form-field>
          <input matInput type="text" [formControl]="userCodeControl(index)" [readonly]="readonly()" maxlength="15"
            placeholder="Enter user code" />
        </mat-form-field>
        @if (userCodeControl(index).touched &&
        userCodeControl(index).hasError('required') &&
        !userCodeControl(index).hasError('whitespace')) {
        <div class="error-text">
          User Code is required
        </div>
        }


      </span>
      @if (!readonly()) {
      <span class="col-action">
        <button type="button" class="provider-remove" (click)="removeProvider(index)"
          [matTooltip]="'Remove ' + providers[index].name">
          <mat-icon>close</mat-icon>
        </button>

      </span>
      }
    </div>
    }
  </div>
  } @else {
  <div class="providers-empty">
    <mat-icon>shield</mat-icon>
    <p>No insurance providers added</p>
    <span>Select a provider above to add it, then enter its user code.</span>

  </div>
  }

  <div class="editor-actions">
    @if(!readonly()){
    <button mat-stroked-button type="button" (click)="cancelSection()">Cancel</button>
    }
    @if(!readonly()){
    <button type="button" class="save-btn" (click)="saveSection()" [disabled]="isVisible()">
      <mat-icon>save</mat-icon>
      Save
    </button>
    }
  </div>

</div>